import { render, staticRenderFns } from "./manualhandlingpage.vue?vue&type=template&id=04d38f45"
import script from "./manualhandlingpage.vue?vue&type=script&lang=js"
export * from "./manualhandlingpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports